// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qlZO","colBig":"styles_colBig__6thmU","colSmall":"styles_colSmall__3cNRa"};